import { Component, OnInit } from '@angular/core';
import * as AOS from 'aos';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.scss']
})
export class BlogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
    // Initialize AOS (Animate On Scroll) library
    AOS.init({
      duration: 1000,
      once: true,
      offset: 100
    });
  }

}
